

    require('./marker/MarkLineModel');
    require('./marker/MarkLineView');

    require('../echarts').registerPreprocessor(function (opt) {
        // Make sure markLine component is enabled
        opt.markLine = opt.markLine || {};
    });



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/markLine.js
// module id = p1Ck
// module chunks = 5